import A2IMLanding from './A2IMLanding'

export default A2IMLanding;